import { GetUrbantzRoundPresetsQuery, UrbantzRoundPresetFragmentFragment } from 'data/__generated__';
import { GET_URBANTZ_ROUND_PRESETS_QUERY } from 'data/queries/urbantzRoundPreset';
import { apolloClient } from '../../../App';

export const urbantzRoundPresetsUpdatedOrCreatedHandler = (
    urbantzRoundPresetsUpdatedOrCreated: UrbantzRoundPresetFragmentFragment[],
) => {
    const result = apolloClient.readQuery<GetUrbantzRoundPresetsQuery>({ query: GET_URBANTZ_ROUND_PRESETS_QUERY });
    if (!result) {
        return;
    }
    const currentUrbantzRoundPresets = result.getUrbantzRoundPresets;

    const updatedOrCreatedUrbantzRoundPresetIds = urbantzRoundPresetsUpdatedOrCreated.map(({ _id }) => _id);
    const nonUpdatedOrCreatedUrbantzRoundPresets = currentUrbantzRoundPresets.filter(
        ({ _id }) => !updatedOrCreatedUrbantzRoundPresetIds.includes(_id),
    );
    const newUrbantzRoundPresets = [...urbantzRoundPresetsUpdatedOrCreated, ...nonUpdatedOrCreatedUrbantzRoundPresets];

    apolloClient.writeQuery({
        query: GET_URBANTZ_ROUND_PRESETS_QUERY,
        data: { getUrbantzRoundPresets: newUrbantzRoundPresets },
    });
};

export const urbantzRoundPresetsDeletedHandler = (deletedUrbantzRoundPresetIds: string[]) => {
    const result = apolloClient.readQuery<GetUrbantzRoundPresetsQuery>({ query: GET_URBANTZ_ROUND_PRESETS_QUERY });
    if (!result) {
        return;
    }
    const currentUrbantzRoundPresets = result.getUrbantzRoundPresets;

    const nonDeletedUrbantzRoundPresets = currentUrbantzRoundPresets.filter(
        ({ _id }) => !deletedUrbantzRoundPresetIds.includes(_id),
    );

    apolloClient.writeQuery({
        query: GET_URBANTZ_ROUND_PRESETS_QUERY,
        data: { getUrbantzRoundPresets: nonDeletedUrbantzRoundPresets },
    });
};
